export const subscriptionReducer = (
	state = {
		list: undefined,
		count: 0,
		data: [],
		details: undefined,
		detail: undefined,
	},
	action
) => {
	switch (action.type) {
		case "SUBSCRIPTION_LIST_SUCCESS":
		case "SUBSCRIPTION_SEARCH_SUCCESS":
			return {
				...state,
				list: action.payload.list,
				count: action.payload.count,
				data: action.payload.data,
			};
		case "SUBSCRIPTION_DETAILS":
			return {
				...state,
				details: action.payload?.details,
			};

		case "SUBSCRIPTION_TOGGLE_SUCCESS":
			return {
				...state,
				details: { ...state?.details, isActive: !state?.details?.isActive },
			};
		case "SUBSCRIPTION_SEARCH_CLEAR":
			return {
				...state,
				list: undefined,
				count: 0,
			};
		default:
			return state;
	}
};
